// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__26KvR","ranges":"BmiRanges_ranges__2iYO2"};